export default "__VITE_ASSET__3TssN0Y___"